export default class ChangedSportsModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.sports === undefined || content.sports.change === undefined) {
            return;
        }

        const sports = content.sports.change;

        for (let i = 0; i < sports.length; i++) {
            const sport = sports[i];

            const key = this._modelKeyRepository.getSportKey(sport.id);

            sports[i] = Object.assign({
                name: sport.n,
                priority: sport.p
            }, key);
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/ChangedSportsModifier.js